var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"players-list",style:({ maxHeight: _vm.height + 'px' })},_vm._l((_vm.players),function(player,playerIndex){return _c('PlayersListItem',{key:playerIndex,attrs:{"player":player,"listVariant":_vm.listVariant}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }